module.exports = __webpack_public_path__ + "img/avalanche.9bca646b.jpeg";